import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';
import get from 'lodash.get';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import { HpSharedModuleContainer } from '../HpSharedModuleContainer/HpSharedModuleContainer';
import { HpRespShopByModuleItem } from './HpRespShopByModuleItem';
import { HpRespShopByModuleLocations } from './HpRespShopByModuleLocations';
import {
    trackShopByItemsImpressions,
    trackShopByLocationsImpressions,
    trackShopByItemClick,
} from './helpers/ShopByTracking';
import { ATTRS_L1_CREATOR, ATTRS_ATTRIBUTE } from './gaConstants';
import { HpSharedInViewport } from '../HpSharedInViewport/HpSharedInViewport';

import styles from './HpRespShopByModule.scss';

class HpRespShopByModuleComponent extends Component {
    shopByModule = get(this.props, 'homepage.shopByModule');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.shopByModule && inViewport) {
            const { items } = this.shopByModule;
            trackShopByItemsImpressions(items);
            trackShopByLocationsImpressions();
        }
    };

    render() {
        if (!this.shopByModule) {
            return null;
        }

        const { items, title, location } = this.shopByModule;

        return (
            <HpSharedModuleContainer addTopGap>
                <PageLayout setViewportBackground={'sassyColorBuyerTertiary'}>
                    <HpSharedModuleContainer.Header>{title}</HpSharedModuleContainer.Header>
                    <HpSharedInViewport
                        stopWhenInViewport
                        onInViewportChange={this.handleInitialDisplay}
                    >
                        <div className={classnames('rowFlex', styles.shopByWrapper)}>
                            <div className="colXs12 colXl8">
                                <div className={classnames('rowFlex', styles.itemsWrapper)}>
                                    {items.map((item, index) => {
                                        const isTopRow = index < 4;

                                        return (
                                            <HpRespShopByModuleItem
                                                key={item.cmsId}
                                                item={item}
                                                isTopRow={isTopRow}
                                                className={
                                                    isTopRow ? 'colXs6 colLg3' : 'colXs12 colMd4'
                                                }
                                                attrs={
                                                    isTopRow ? ATTRS_L1_CREATOR : ATTRS_ATTRIBUTE
                                                }
                                                onClick={() => trackShopByItemClick(item, index)}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="colXs12 colXl4">
                                <HpRespShopByModuleLocations location={location} />
                            </div>
                        </div>
                    </HpSharedInViewport>
                </PageLayout>
            </HpSharedModuleContainer>
        );
    }
}

HpRespShopByModuleComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespShopByModule = createFragmentContainer(HpRespShopByModuleComponent, {
    homepage: graphql`
        fragment HpRespShopByModule_homepage on Homepage {
            shopByModule: module(type: "shopBy") {
                ... on ShopByModule {
                    title
                    location {
                        title
                        imageUrl
                        items {
                            cmsId
                            title
                            link
                        }
                    }
                    items {
                        cmsId
                        title
                        link
                        imageUrl
                    }
                }
            }
        }
    `,
});
